module.exports = __webpack_public_path__ + "04eb8fc57f27498e5ae37523e3bfb2c7.woff";